import styled from 'styled-components';
import TermsAndConditions from '../../../register/termsAndConditions';

export const StyledConsentAgeHeading = styled.p`
    display: flex;
    justify-content: center;
    margin: var(--spacing-2) 0 var(--spacing-5);
`;

export const StyledTermsAndConditions = styled(TermsAndConditions)`
    margin-bottom: var(--spacing-1);
`;
